import * as types from "../actions/actionTypes";
import initialState from "./initialState";
import { ExitActions } from "../actions/exitActions";

export default function canLeaveReducer(state = initialState.canLeave, action: ExitActions): boolean {
    switch (action.type) {
        case types.CAN_LEAVE_UPDATED: {
            return action.canLeave;
        }
        default:
            return state;
    }
}
